import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { addDays, format, FORMAT_MONTH_DAY_YEAR, isAfter } from 'helpers/DateTimeHelper';
import { setCookie } from 'helpers/Storage';
import { getFormattedDomain } from 'helpers/ConfigHelper';

import Style from '../../FeatureFlag.module.scss';

const Card = ({
  brand,
  checked,
  dateAdded,
  description,
  flagName,
  jiraTicketNumber,
  name,
  nickname,
  permanent,
}) => {
  const [toggled, setToggle] = useState(checked);
  const dateModified = new Date(dateAdded);
  const isExpired = isAfter(addDays(new Date(), -30), dateModified) && !permanent;
  const formattedDomain = getFormattedDomain();

  const handleToggleFeatureFlag = value => {
    setToggle(value);
    const options = { domain: formattedDomain, path: '/' };
    setCookie({ name: flagName, value, options });
  };

  return (
    <div className={Style.card}>
      <div className={Style.main}>
        <div className={Style.iconWrapper}>
          <div className={classNames([Style.abbrev, Style[brand]])}>
            <span>{nickname}</span>
          </div>
        </div>
        <div className={Style.content}>
          <div className={Style.name} role="heading" aria-level="3">
            {name}
          </div>
          <div className={Style.description}>{description}</div>
        </div>
      </div>
      <div className={Style.actionBar}>
        <div className={classNames([Style.dateAdded, isExpired ? Style.expired : null])}>
          <div>{`Last updated:   ${format(dateModified, FORMAT_MONTH_DAY_YEAR)}`}</div>
        </div>
        <a
          className={Style.ticket}
          href={`https://teamfox.atlassian.net/browse/${jiraTicketNumber}`}
          target="_new"
        >
          Feature details
        </a>
        <label className={Style.switch}>
          <input
            type="checkbox"
            checked={toggled}
            onChange={() => handleToggleFeatureFlag(!toggled)}
          />
          <span className={classNames([Style.slider, Style.round])} />
        </label>
      </div>
    </div>
  );
};

Card.propTypes = {
  brand: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  dateAdded: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  flagName: PropTypes.string.isRequired,
  jiraTicketNumber: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  nickname: PropTypes.string.isRequired,
  permanent: PropTypes.bool.isRequired,
};

Card.defaultProps = {
  checked: false,
};

export default Card;
